import React, { PropsWithChildren } from 'react';
import './responsiveLabel.scss'; // Updated import for the SCSS file
import { ResponsiveLabelProps } from './responsiveLabel.interface';
import { Box } from '@amzn/awsui-components-react-v3';

const ResponsiveLabel = ({ children }: PropsWithChildren<ResponsiveLabelProps>) => {
	return <Box className="truncate-text">
		<label>{children}</label>
	</Box>;
};

export default ResponsiveLabel;
